// SearchStory.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import SearchStoryList from '../container/SearchStoryList.js';

import Loading from '../component/Loading.jsx';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { textColor } from '../style/variables.js';

import EmptyResultIconResource from '../../img/img-empty-nofollowing.svg';

export class SearchStory extends React.PureComponent {
  fetchData = () => {
    const {
      sortingString,
      query,
      defaultStoryCategory,
      hasQuery,
      isActive,
      fetchMessageSearch,
      fetchFeeds,
    } = this.props;
    if (!isActive) {
      return;
    }
    if (hasQuery) {
      return fetchMessageSearch({
        query,
        type: 'story',
        sortings: sortingString.split('&').filter(i => i),
      });
    }
    return fetchFeeds({
      type: defaultStoryCategory,
    });
  };
  componentDidMount() {
    const { isStoryFetched } = this.props;
    if (!isStoryFetched) {
      this.fetchData();
    }
  }
  componentDidUpdate(prevProps) {
    const { query, isAuthed, isActive, sortingString } = this.props;
    if (
      isAuthed !== prevProps.isAuthed ||
      query !== prevProps.query ||
      isActive !== prevProps.isActive ||
      sortingString !== prevProps.sortingString
    ) {
      this.fetchData();
    }
  }
  render() {
    const { type, category, isStoryFetched, storyIds, t } = this.props;
    const isLoading = !isStoryFetched;
    const isEmpty = storyIds.length === 0;
    if (isEmpty) {
      if (isLoading) {
        // only show loading when list is empty to prevent scroll height loss.
        return (
          <StyledSearchAll>
            <LoadingWrapper>
              <Loading />
            </LoadingWrapper>
          </StyledSearchAll>
        );
      }
      return (
        <StyledSearchAll>
          <EmptyResultWrapper>
            <EmptyResultIcon src={EmptyResultIconResource} />
            {t('search_no_result', {
              ns: TranslationNamespace.SEARCH,
            })}
          </EmptyResultWrapper>
        </StyledSearchAll>
      );
    }
    return (
      <StyledSearchAll>
        <SearchStoryList type={type} category={category} />
      </StyledSearchAll>
    );
  }
}

SearchStory.propTypes = {
  sortingString: PropTypes.string,
  query: PropTypes.string,
  type: PropTypes.string,
  category: PropTypes.string,
  defaultStoryCategory: PropTypes.string,
  isAuthed: PropTypes.bool,
  isStoryFetched: PropTypes.bool,
  hasQuery: PropTypes.bool,
  isActive: PropTypes.bool,
  storyIds: PropTypes.array,
  fetchFeeds: PropTypes.func,
  fetchMessageSearch: PropTypes.func,
  t: PropTypes.func.isRequired,
};

SearchStory.defaultProps = {
  sortingString: '',
  query: '',
  type: '',
  category: '',
  defaultStoryCategory: '',
  isAuthed: false,
  isStoryFetched: false,
  hasQuery: false,
  isActive: false,
  storyIds: [],
  fetchFeeds: () => null,
  fetchMessageSearch: () => null,
};

const StyledSearchAll = styled.div``;

const LoadingWrapper = styled.div`
  margin-top: 52px;
`;

const EmptyResultWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${textColor.black};
  font-size: 14px;
`;

const EmptyResultIcon = styled.img`
  margin-bottom: 12px;
  height: 120px;
  width: auto;
`;

export default withTranslation()(SearchStory);
